import {
  Landmark,
  Globe2,
  Layers,
  Shield,
  Building2,
  Factory,
  Cpu,
  Users2,
  Leaf,
  Camera,
  Flame,
  ClipboardList,
  ArrowRight
} from "lucide-react";

export default function CentralGovernmentAdvisory() {
  const sections = [
    {
      id: "cross-ministry",
      title: "Cross-Ministry Strategy & Policy Advisory",
      icon: Landmark,
      accent: "Long-term, cross-ministerial strategy and policy reform support.",
      points: [
        "Long-term visioning, sectoral master planning, and policy reform",
        "Program and scheme design, restructuring, and convergence",
        "Outcome-based planning, Monitoring & Evaluation (M&E), and impact assessment",
        "Inter-ministerial coordination and institutional strengthening"
      ],
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "infrastructure-energy",
      title: "Infrastructure, Energy & Natural Resources Advisory",
      icon: Layers,
      accent: "End-to-end advisory across core infrastructure, energy, and natural resources.",
      points: [
        "Water resources, irrigation, dams, and climate-resilient infrastructure",
        "Power, renewable energy, storage, and energy transition planning",
        "Roads, highways, logistics corridors, ports, waterways, and aviation infrastructure",
        "Railways, freight, multimodal integration, and station redevelopment"
      ],
      image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "defence-strategic",
      title: "Defence, Strategic Assets & National Infrastructure",
      icon: Shield,
      accent: "Strategic advisory for defence infrastructure and national capabilities.",
      points: [
        "Defence infrastructure planning and modernization",
        "Strategic logistics, indigenization, and defence manufacturing advisory",
        "Procurement, offset policy, and PPP participation advisory"
      ],
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "urban-rural",
      title: "Urban, Housing & Rural Development Advisory",
      icon: Building2,
      accent: "Balanced urban and rural development planning and implementation support.",
      points: [
        "Urban master planning, smart cities, housing, and mobility",
        "Rural infrastructure, connectivity, livelihoods, and social development",
        "Integrated rural-urban development planning"
      ],
      image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "agriculture-food",
      title: "Agriculture, Food Security & Supply Chain Advisory",
      icon: Globe2,
      accent: "Strengthening agri-infra, value chains, and food security systems.",
      points: [
        "Agricultural infrastructure and irrigation linkage",
        "Food processing, cold chains, warehousing, and logistics",
        "Public distribution systems, food security, and digitization"
      ],
      image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "financial-economic",
      title: "Financial, Economic & Industrial Policy Advisory",
      icon: Factory,
      accent: "Macro, financial sector, and industrial policy support.",
      points: [
        "Financial sector reforms, public finance, and budgeting",
        "Banking, capital markets, insurance, and asset monetization",
        "Industrial policy, manufacturing clusters, SEZs, and export promotion",
        "Ease of doing business and corporate governance reforms"
      ],
      image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "digital-egov",
      title: "Digital, IT & E-Governance Advisory",
      icon: Cpu,
      accent: "Digital public infrastructure, e-governance, and cybersecurity advisory.",
      points: [
        "Digital infrastructure, data centers, and e-governance",
        "Cybersecurity, digital transformation, and IT modernization"
      ],
      image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "social-sector",
      title: "Social Sector Advisory",
      icon: Users2,
      accent: "Human development, social protection, and skills-focused advisory.",
      points: [
        "Healthcare and education infrastructure planning",
        "Public health programs, medical education, and skill development",
        "Workforce development, employment, and social security programs"
      ],
      image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "environment-climate",
      title: "Environment, Climate & Sustainability Advisory",
      icon: Leaf,
      accent: "Mainstreaming climate resilience, ESG, and green finance.",
      points: [
        "Environmental planning and regulatory advisory",
        "Climate resilience, adaptation, ESG, and green finance",
        "Carbon markets and sustainability frameworks"
      ],
      image: "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "tourism-culture",
      title: "Tourism, Culture & Sectoral Development",
      icon: Camera,
      accent: "Tourism, heritage, and sector-specific cluster development.",
      points: [
        "Tourism destination and heritage infrastructure planning",
        "PPP structuring for tourism and cultural projects",
        "Sector-specific cluster and value-chain development"
      ],
      image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "mining-energy-security",
      title: "Mining, Energy Security & Strategic Resources",
      icon: Flame,
      accent: "Resource security, logistics, and strategic energy planning.",
      points: [
        "Mining infrastructure, logistics, and sustainability advisory",
        "Oil, gas, pipelines, and strategic reserve planning"
      ],
      image: "https://images.unsplash.com/photo-1513828583688-c52646db42da?w=1200&q=80&auto=format&fit=crop"
    },
    {
      id: "integrated-execution",
      title: "Integrated Government Project Execution Support",
      icon: ClipboardList,
      accent: "End-to-end project development, transaction, and execution support.",
      points: [
        "DPRs, techno-economic feasibility, and financial modeling",
        "PMC, program management, and PPP transaction advisory",
        "Procurement, tendering, contract management, and monitoring",
        "Post-implementation evaluation and outcome assessment"
      ],
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80&auto=format&fit=crop"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Advisory Services to the Central Government of India
            </h1>
            <p className="text-xl md:text-2xl text-yellow-50 mb-4">
              Ministry-Wise & Cross-Sectoral Coverage
            </p>
            <p className="text-yellow-100 text-lg">
              Strategic, sectoral, and execution-focused support across Central
              Ministries, Departments, PSUs, and Autonomous Bodies for policy,
              planning, project development, financing, and monitoring
            </p>
          </div>
        </div>
      </section>

      {/* Universal Coverage Statement */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
            Universal Coverage Across Central Government Ecosystem
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Advisory services typically extend across all Central Government
            Ministries, Departments, PSUs, and Autonomous Bodies, covering
            policy formulation, sectoral planning, project development, funding
            strategies, execution support, and outcome monitoring, in alignment
            with Government of India procedures and frameworks.
          </p>
        </div>
      </section>

      {/* Section Cards */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 space-y-16">
          {sections.map((section, index) => {
            const Icon = section.icon;
            return (
              <div
                key={section.id}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } gap-10 items-center`}
              >
                {/* Image */}
                <div className="w-full lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                    <img
                      src={section.image}
                      alt={section.title}
                      className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/65 to-transparent" />
                    <div className="absolute bottom-6 left-6 flex items-center gap-3 text-white">
                      <div className="p-3 bg-yellow-500 rounded-lg">
                        <Icon className="w-7 h-7" />
                      </div>
                      <h3 className="text-xl md:text-2xl font-bold">{section.title}</h3>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="w-full lg:w-1/2">
                  <div className="bg-gray-50 rounded-2xl p-8 border-2 border-gray-200 hover:border-yellow-500 transition-all duration-300">
                    <p className="text-yellow-600 font-semibold mb-4">
                      {section.accent}
                    </p>
                    <ul className="space-y-3">
                      {section.points.map((point, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <span className="mt-2 inline-block w-2 h-2 rounded-full bg-yellow-500 flex-shrink-0" />
                          <span className="text-gray-700 leading-relaxed">
                            {point}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 bg-black">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="flex items-start gap-4">
            <div className="mt-1">
              <Shield className="w-7 h-7 text-yellow-500 flex-shrink-0" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Important Disclaimer
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed mb-2">
                All advisory services are provided in alignment with applicable
                Central Government policies, statutory frameworks, and
                prescribed approval processes. Decisions relating to policies,
                programs, projects, and approvals remain solely with the
                Government of India and its competent authorities.
              </p>
              <p className="text-sm text-gray-400">
                Inputs are typically advisory in nature, supporting analysis,
                design, documentation, and implementation planning, while
                sovereign functions, approvals, and final decisions rest
                exclusively with government institutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Explore Ministry-Wise or Cross-Sectoral Engagement
          </h2>
          <p className="text-lg text-yellow-50 mb-8">
            Engagements can be structured for specific ministries, flagship
            programs, or cross-cutting government initiatives requiring policy,
            infrastructure, social sector, or digital transformation support.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
            >
              Connect with Advisory Team
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="mailto:info@hawkinsandbrooks.com"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-yellow-600 transition-all duration-300"
            >
              Write for Government Engagements
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
